import { ISettlementTeam, ISigner } from '../../types/Parties';
import {
  IFnmToJson,
  ILookupData,
  TBasisType,
  TDataSection,
  TLoanPurpose,
  TMaritalStatus,
  TResidencyType,
  TSubmissionType,
} from './../../types/Files.d';
import { IEscrowMember } from './../../types/Parties';

/**
 * TODO:
 * - fix @ts-ignore
 */
import { constructPhoneObject } from './helpers';

export const threeTwoParser = (fnmFile: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function () {
      const extract: IFnmToJson = {
        fileName: '',
        fileType: '',
        signers: [],
        escrowTeam: [],
        settlementTeam: [],
        properties: [],
        amortizationType: undefined,
        loanNumber: '',
      };
      const data: any = {};
      // By lines
      if (this.result) {
        // @ts-ignore
        const lines = this.result.split('\n');
        if (!lines || lines.length === 0) {
          reject(new Error('bad file'));
        }
        for (let line = 0; line < lines.length; line++) {
          const addSection = function (
            section: TDataSection,
            multipleEntrys: boolean
          ) {
            if (!multipleEntrys) {
              data[section] = [];
            } else {
              data[section] = data[section] ? data[section] : [];
            }
            return data[section];
          };
          const parser = makeLineParser(lines[line]);
          if (parser.getRecordID() in lookup) {
            const map: Array<any> =
              lookup[parser.getRecordID() as keyof ILookupData];
            // Can Have Multiple Entrys
            const multipleEntrys = ['10B', '03A', '02C'].includes(
              parser.getRecordID()
            );
            const section = addSection(parser.getRecordID(), multipleEntrys);

            const values = [];

            for (let i = 0; i < map.length; i++) {
              const item = map[i];
              item.data = parser.getData(
                item.position,
                item.length,
                item.process
              );
              if (multipleEntrys) {
                values.push({
                  label: item.label,
                  data: item.data,
                });
              } else {
                section.push({
                  label: item.label,
                  data: item.data,
                });
              }
            }

            if (multipleEntrys) {
              section.push(values);
            }
          }
        }
      }
      extract.escrowTeam = GetEscrowTeam(data);
      extract.signers = GetSigners(data);
      extract.settlementTeam = GetSettlementTeam(data);
      extract.properties = GetProperty(data);
      extract.amortizationType = data['01A'][5]?.data
        ? data['01A'][5]?.data
        : '';
      extract.loanAmount = data['01A'][2]?.data ? data['01A'][2]?.data : '';
      extract.loanType = data['01A'][1]?.data ? data['01A'][1]?.data : '';
      extract.lienPosition = data?.LNC ? data?.LNC[0]?.data : '';
      extract.propertyCounty = data?.GOA ? data?.GOA[0]?.data : '';
      extract.loanPurpose = data['02B'][0]?.data ? data['02B'][0]?.data : '';
      extract.salesPrice = data['07A'][0]?.data ? data['07A'][0]?.data : '';
      extract.lenderNameAndExtension = data['01A'][2]?.data
        ? data['01A'][2]?.data
        : '';
      extract.fileName = fnmFile.name;
      extract.fileType = '3.2';
      resolve(extract);
    };
    reader.readAsText(fnmFile);
  });
};

const GetEscrowTeam = (importData: any): IEscrowMember[] => {
  const array = [];
  for (let i = 0; i < importData['10B'].length; i++) {
    const obj: IEscrowMember = {
      Id: 'import_' + i,
      FirstName: importData['10B'][i][2]?.data.split(' ')[0]
        ? importData['10B'][i][2]?.data.split(' ')[0]
        : '',
      LastName: importData['10B'][i][2]?.data.split(' ')[1]
        ? importData['10B'][i][2]?.data.split(' ')[1]
        : '',
      Type: 'Loan Officer',
      Addresses: [
        {
          Line1: importData['10B'][i][6]?.data
            ? importData['10B'][i][6]?.data
            : '',
          Line2: '',
          Line3: '',
          State: {
            Name: importData['10B'][i][8]?.data
              ? importData['10B'][i][8]?.data
              : '',
            Code: importData['10B'][i][8]?.data
              ? importData['10B'][i][8]?.data
              : '',
          },
          ZipCode: importData['10B'][i][9]?.data
            ? importData['10B'][i][9]?.data
            : '',
          City: '',
          County: '',
          Type: null,
        },
      ],
      PhoneNumbers: importData['10B'][i][4]?.data
        ? [constructPhoneObject(String(importData['10B'][i][4]?.data))]
        : [],
      Emails: [],
    };
    array.push(obj);
  }

  return array;
};

const MapPartyTypes = (type?: string) => {
  if (!type) return undefined;
  switch (type) {
    case 'Applicant':
      return 'Buyer/Borrower';
    case 'Co-Applicant':
      return 'Buyer/Borrower';
    default:
      return undefined;
  }
};

const GetSigners = (importData: any) => {
  const array = [];
  for (let i = 0; i < importData['03A'].length; i++) {
    const obj: ISigner = {
      Id: 'import_' + i,
      FirstName: importData['03A'][i][3]?.data
        ? importData['03A'][i][3]?.data
        : '',
      MiddleName: importData['03A'][i][4]?.data
        ? importData['03A'][i][4]?.data
        : '',
      LastName: importData['03A'][i][5]?.data
        ? importData['03A'][i][5]?.data
        : '',
      SSN: importData['03A'][i][2]?.data ? importData['03A'][i][2]?.data : '',
      SignerType: MapPartyTypes(importData['03A'][i][1]?.data),
      Addresses: [
        {
          Line1: importData['03A'][i][1]?.data
            ? importData['03A'][i][1]?.data
            : '',
          Line2: '',
          Line3: '',
          State: {
            Name: importData['03A'][i][3]?.data
              ? importData['03A'][i][3]?.data
              : '',
            Code: importData['03A'][i][3]?.data
              ? importData['03A'][i][3]?.data
              : '',
          },
          ZipCode: importData['03A'][i][4]?.data
            ? importData['03A'][i][4]?.data
            : '',
          City: importData['03A'][i][2]?.data
            ? importData['03A'][i][2]?.data
            : '',
          County: '',
          Type: null,
        },
      ],
      PhoneNumbers: importData['03A'][i][7]?.data
        ? [constructPhoneObject(String(importData['03A'][i][7]?.data))]
        : [],
      Emails: [],
      PrincipalType: 'Individual',
    };
    array.push(obj);
  }

  return array;
};

const GetSettlementTeam = (importData: any) => {
  const array = [];

  for (let i = 0; i < importData['02C'].length; i++) {
    const obj: ISettlementTeam = {
      Id: 'import_' + i,
      FirstName: importData['02C'][i][1]?.data
        ? importData['02C'][i][1]?.data
        : '',
      MiddleName: '',
      LastName: '',
      Addresses: [],
      PhoneNumbers: [],
      Emails: [],
      // PrincipalType: 'Individual'
    };
    array.push(obj);
  }

  return array;
};

const GetProperty = (importData: any) => {
  return [
    {
      Addresses: [
        {
          Line1: importData['02A'][1]?.data ? importData['02A'][1]?.data : '',
          Line2: '',
          Line3: '',
          State: {
            Name: importData['02A'][3]?.data ? importData['02A'][3]?.data : '',
            Code: importData['02A'][3]?.data ? importData['02A'][3]?.data : '',
          },
          ZipCode: importData['02A'][4]?.data ? importData['02A'][4]?.data : '',
          City: importData['02A'][2]?.data ? importData['02A'][2]?.data : '',
          County: '',
          Type: null,
        },
      ],
      PropertyType: '',
    },
  ];
};

const makeLineParser = function (line: any) {
  return {
    getRecordID: function () {
      return line.substr(0, 3).trim();
    },
    getData: function (
      position: number,
      length: number,
      process: (d: any) => void
    ): string {
      const d = line
        .split('')
        .splice(position - 1, length)
        .join('')
        .trim();
      return process ? process(d) : d;
    },
  };
};

const lookup: ILookupData = {
  '01A': [
    {
      id: '010',
      position: 1,
      length: 3,
      label: 'Mortgage Type and Terms',
    },
    {
      id: '020',
      position: 4,
      length: 2,
      label: 'Mortgage Applied For (Other)',
      process: (d: '01' | '02' | '03' | '04' | '07'): string => {
        const s = {
          '01': 'Conventional',
          '02': 'VA',
          '03': 'FHA',
          '04': 'USDA / Rural Housing Service',
          '07': 'Other',
        };
        return d in s ? s[d] : '';
      },
    },
    {
      position: 131,
      length: 15,
      label: 'Loan Amount',
      process: (a: string): number => parseFloat(a),
    },
    {
      position: 146,
      length: 7,
      label: 'Interest Rate',
      process: (a: string): number => parseFloat(a),
    },
    {
      position: 153,
      length: 3,
      label: 'No. of Months',
      process: (a: string): number => parseFloat(a),
    },
    {
      position: 156,
      length: 2,
      label: 'Amortization Type',
      process: (a: '01' | '04' | '05' | '06'): string => {
        const l = {
          '01': 'Adjustable Rate',
          '04': 'GEM',
          '05': 'Fixed Rate',
          '06': 'GPM',
          13: 'Other',
        };
        if (a in l) {
          return l[a];
        }
        return '';
      },
    },
    {
      position: 158,
      length: 80,
      label: 'Amortization Type Other Explanation',
    },
  ],
  '02A': [
    {
      position: 1,
      length: 3,
      label: 'Information',
    },
    {
      position: 4,
      length: 50,
      label: 'Street Address',
    },
    {
      position: 54,
      length: 35,
      label: 'City',
    },
    {
      position: 89,
      length: 2,
      label: 'State',
    },
    {
      position: 91,
      length: 5,
      label: 'Zip Code',
    },
  ],
  '02B': [
    {
      position: 6,
      length: 2,
      label: 'Loan Purpose',
      process: (a: '04' | '05' | 13 | 15 | 16): string => {
        const l = {
          '04': 'Construction',
          '05': 'Refinance',
          13: 'Construction-Perm',
          15: 'Other',
          16: 'Purchase',
        };
        if (a in l) {
          return l[a];
        }
        return '';
      },
    },
  ],
  '02C': [
    {
      position: 1,
      length: 3,
      label: 'Settlement Team Data',
    },
    {
      position: 4,
      length: 35,
      label: 'First Name',
    },
  ],
  '03A': [
    {
      position: 1,
      length: 3,
      label: 'Applicant(s) Data',
    },
    {
      position: 4,
      length: 2,
      label: 'Applicant or Co-Applicant',
      process: (d: string): string => {
        return d && d === 'BW' ? 'Applicant' : 'Co-Applicant';
      },
    },
    {
      position: 6,
      length: 9,
      label: 'SSN',
    },
    {
      position: 15,
      length: 35,
      label: 'First Name',
    },
    {
      position: 50,
      length: 35,
      label: 'Middle Name',
    },
    {
      position: 85,
      length: 35,
      label: 'Last Name',
    },
    {
      position: 120,
      length: 4,
      label: 'Generation',
    },
    {
      position: 124,
      length: 10,
      label: 'Home Phone',
    },
    {
      position: 134,
      length: 3,
      label: 'Age',
    },
    {
      position: 137,
      length: 2,
      label: 'Years School',
    },
    {
      position: 139,
      length: 1,
      label: 'Martial Status',
      process: (d: string): string | undefined => {
        const s: TMaritalStatus = {
          M: 'Married',
          S: 'Separated',
          U: 'Unmarried',
        };
        if (d in s) {
          return s[d as keyof TMaritalStatus];
        }
      },
    },
    {
      position: 160,
      length: 30,
      label: 'Email',
    },
  ],
  '03C': [
    {
      position: 1,
      length: 3,
      label: 'Applicant(s) Address',
    },
    {
      position: 4,
      length: 9,
      label: 'SSN',
    },
    {
      position: 13,
      length: 2,
      label: 'Residency Type',
      process: (d: string): string | undefined => {
        const s: TResidencyType = {
          F4: 'Former Residence',
          ZG: 'Present Residence',
          BH: 'Mailing Address',
        };
        if (d in s) {
          return s[d as keyof TResidencyType];
        }
      },
    },
    {
      position: 15,
      length: 50,
      label: 'Street Address',
    },
    {
      position: 65,
      length: 35,
      label: 'City',
    },
    {
      position: 100,
      length: 2,
      label: 'State',
    },
    {
      position: 102,
      length: 5,
      label: 'Zip Code',
    },
    {
      position: 107,
      length: 4,
      label: 'Zip Code Plus Four',
    },
    {
      position: 111,
      length: 1,
      label: 'Basis Type',
      process: (d: string) => {
        const s: TBasisType = {
          X: 'Living Rent Free',
          R: 'Rent',
          O: 'Own',
        };
        if (d in s) {
          return s[d as keyof TBasisType];
        }
      },
    },
    {
      position: 112,
      length: 2,
      label: 'Duration Years',
      process: (d: string): number | string => (d ? parseInt(d, 10) : ''),
    },
    {
      position: 114,
      length: 2,
      label: 'Duration Months',
      process: (d?: string): number | string | undefined => {
        if (d) {
          let n;
          n = parseInt(d, 10);
          if (n > 11 && n < 0) {
            n = '';
          }
          return n;
        }
        return d;
      },
    },
    {
      position: 116,
      length: 50,
      label: 'Country',
    },
  ],
  '04A': [
    {
      position: 1,
      length: 3,
      label: 'Borrower Employer',
    },
    {
      position: 4,
      length: 9,
      label: 'SSN',
    },
    {
      position: 13,
      length: 35,
      label: 'Employer Name',
    },
    {
      position: 48,
      length: 35,
      label: 'Employer Street Address',
    },
    {
      position: 83,
      length: 35,
      label: 'Employer City',
    },
    {
      position: 118,
      length: 2,
      label: 'Employer State',
    },
    {
      position: 120,
      length: 5,
      label: 'Employer Zip Code',
    },
    {
      position: 125,
      length: 4,
      label: 'Employer Zip Code Plus Four',
    },
    {
      position: 129,
      length: 1,
      label: 'Self Employed',
    },
    {
      position: 130,
      length: 2,
      label: 'Years On Job',
    },
    {
      position: 132,
      length: 2,
      label: 'Months On Job',
    },
    {
      position: 134,
      length: 2,
      label: 'Number of Years in this line of work',
    },
    {
      position: 136,
      length: 25,
      label: 'Employment Position Description',
    },
    {
      position: 161,
      length: 10,
      label: 'Employer Phone Number',
    },
  ],
  '06G': [
    {
      position: 6,
      length: 2,
      label: 'Loan Purpose',
      process: (a: string | number): string => {
        const l: TLoanPurpose = {
          14: 'Single Family',
          '04': 'Condominium',
          16: 'Townhouse',
          13: 'Co-operative',
          15: 'Two-to-four unit property',
          18: 'Multifamily (more than 4 units)',
          '08': 'Manufactured/Mobile Home',
          '02': 'Commercial – Non-Residential',
          F1: 'Mixed Use – Residential',
          '05': 'Farm',
          '03': 'Home and Business Combined',
          '07': 'Land',
        };
        if (a in l) {
          return l[a as keyof TLoanPurpose];
        }
        return '';
      },
    },
  ],
  '07A': [
    {
      position: 9,
      length: 10,
      label: 'Sales Price',
    },
  ],
  '10B': [
    {
      position: 1,
      length: 3,
      label: 'Loan Originator Information',
    },
    {
      position: 4,
      length: 1,
      label: 'This application was taken by',
      process: (d: string) => {
        const s: TSubmissionType = {
          F: 'Face-to-Face',
          M: 'Mail or Fax',
          T: 'Telephone',
          I: 'Internet or E-Mail',
        };
        return d in s ? s[d as keyof TSubmissionType] : '';
      },
    },
    {
      position: 5,
      length: 60,
      label: 'Name',
    },
    {
      position: 65,
      length: 8,
      label: 'The date of loan origin',
    },
    {
      position: 73,
      length: 10,
      label: 'Phone number',
    },
    {
      position: 83,
      length: 35,
      label: 'Loan Origination Company’s Name',
    },
    {
      position: 118,
      length: 35,
      label: 'Street Address',
    },
    {
      position: 153,
      length: 35,
      label: 'Street Address 2',
    },
    {
      position: 223,
      length: 2,
      label: 'State Code',
    },
    {
      position: 225,
      length: 5,
      label: 'Zip Code',
    },
    {
      position: 230,
      length: 4,
      label: 'Zip Code Plus 4',
    },
  ],
  LNC: [
    {
      position: 31,
      length: 10,
      label: 'Lien Position',
    },
  ],
  GOA: [
    {
      position: 102,
      length: 35,
      label: 'Property County',
    },
  ],
};
